var delta = delta || {};
delta.utility = function () {

    //
    // setup the date picker control
    //
    setupDatePicker = function ($parent) {

        // determine if $parent is modal or not
        var $modalBodyElements = $parent.find('.modal-body');
        var classes = $modalBodyElements.length > 0 ? '.modal-body .datepicker' : '.datepicker';
        var $dt = $parent.find(classes);
        
        
        $dt.datepicker({
            autoclose: true,
            todayHighlight: true
        });

        //make the icon clickable
        $dt.closest('div').find('i').click(function() {
            //seems safer to do it this way since we may have multiple elements
            $(this).closest('div.form-group-feedback').find('input').focus();
        });
    },


    dummy = function() {};

    return {
        setupDatePicker: setupDatePicker,
    };
}();